// Funtion
import adjustViewport from './function/adjustViewport';

// Module
import Accordion from './module/Accordion';
import FormValidate from './module/FormValidate';
import HamburgerMenu from './module/HamburgerMenu';
import LangOnlyJapanese from './module/LangOnlyJapanese';
import LanguageModal from './module/LanguageModal';
import RestaurantDetailSlider from './module/RestaurantDetailSlider';
import RestaurantRouteMap from './module/RestaurantRouteMap';
import ScrollAddClass from './module/ScrollAddClass';
import SmoothScroll from './module/SmoothScroll';
import Tab from './module/Tab';

// Page
import SingleRestaurant from './page/SingleRestaurant';

// Page
// import Home from './page/Home';

const init = () => {
  (() => {
    const singleRestaurant = new SingleRestaurant();
    singleRestaurant.init();
  })();

  (() => {
    const smoothScroll = new SmoothScroll({
      targets: 'a[href^="#"]',
      fixHeader: '#js-header',
    });
    smoothScroll.init();
  })();

  (() => {
    const scrollAddClass = new ScrollAddClass({});
    scrollAddClass.init();
  })();

  (() => {
    const langOnlyJapanese = new LangOnlyJapanese();
    langOnlyJapanese.init();
  })();

  (() => {
    const accordion = new Accordion();
    accordion.init();
  })();

  (() => {
    const recruitmentFormValidate = new FormValidate({
      form: '#js-form form',
    });
    recruitmentFormValidate.init();
  })();

  (() => {
    const tab = new Tab();
    tab.init();
  })();

  (() => {
    const hamburgerMenu = new HamburgerMenu();
    hamburgerMenu.init();
  })();

  (() => {
    const languageModal = new LanguageModal();
    languageModal.init();
  })();

  // (() => {
  //   const home = new Home({
  //     parent: '#js-home-page',
  //   });
  //   home.init();
  // })();

  (() => {
    // 新着記事用スライダー
    (() => {
      var splide = document.querySelector('#card-splide');
      if (!splide) return;
      new Splide('#card-splide', {
        gap: '35px',
        arrows: true,
        trimSpace: false,
        focus: '0',
        autoHight: 'true',
        classes: {
          pagination: 'splide__pagination c-card-splide-pagination',
          page: 'splide__pagination__page c-card-splide-page',
        },
        breakpoints: {
          768: {
            arrows: false,
            gap: '25px',
          },
        },
      }).mount();
    })();

    // インタビュー用スライダー
    (() => {
      var splide = document.querySelector('#interview-splide');
      if (!splide) return;
      new Splide('#interview-splide', {
        gap: '35px',
        arrows: true,
        trimSpace: false,
        focus: '0',
        classes: {
          pagination: 'splide__pagination c-card-splide-pagination p-interview-slider__pagination',
          page: 'splide__pagination__page c-card-splide-page',
        },
        breakpoints: {
          768: {
            arrows: false,
            gap: '25px',
          },
        },
      }).mount();
    })();

    // バナースライド
    (() => {
      var splide = document.querySelector('#banner-splide');
      if (!splide) return;
      new Splide('#banner-splide', {
        arrows: true,
        classes: {
          pagination: 'splide__pagination c-splide-pagination p-modal__pagination',
          page: 'splide__pagination__page c-splide-page p-modal__page',
        },
        breakpoints: {
          960: {
            arrows: false,
          },
        },
      }).mount();
    })();

    // フィロソフィーページスライド
    (() => {
      var splide = document.querySelector('#philosophy-splide');
      if (!splide) return;
      new Splide('#philosophy-splide', {
        arrows: true,
        type: 'loop',
        classes: {
          pagination: 'splide__pagination c-splide-pagination p-philosophy-fv__pagination',
          page: 'splide__pagination__page c-splide-page p-philosophy-fv__page',
        },
        breakpoints: {
          768: {
            arrows: false,
          },
        },
      }).mount();
    })();

    // 農園事業ページ 野菜品目
    (() => {
      var splide = document.querySelector('#agriculture-splide');
      if (!splide) return;
      new Splide('#agriculture-splide', {
        gap: '30px',
        arrows: true,
        pagination: true,
        trimSpace: false,
        start: 3,
        focus: 'center', // アクティブなスライドを中央にする
        classes: {
          pagination: 'splide__pagination p-agriculture-vegetables__pagination',
          page: 'splide__pagination__page p-agriculture-vegetables__page',
        },
        breakpoints: {
          768: {
            start: 0,
            arrows: false,
            gap: '10px',
            trimSpace: true,
            focus: '0',
            padding: '20px', // スライダーの左右の余白
          },
        },
      }).mount();
    })();

    // レストランページスライダー（ランチ）
    (() => {
      var splide = document.querySelector('#lunch-splide');
      if (!splide) return;
      new Splide('#lunch-splide', {
        breakpoints: {
          768: {
            arrows: false,
            gap: '25px',
          },
        },
      }).mount();
    })();

    // レストランページスライダー（ディナー）
    (() => {
      var splide = document.querySelector('#dinner-splide');
      if (!splide) return;
      new Splide('#dinner-splide', {
        breakpoints: {
          768: {
            arrows: false,
            gap: '25px',
          },
        },
      }).mount();
    })();

    // 路線図店舗マップのスライダー
    (() => {
      const mapSplideElement = document.querySelector('#map-splide');
      if (!mapSplideElement) return;
      const restaurantRouteMap = new RestaurantRouteMap();
      restaurantRouteMap.init();
    })();

    // ブランド系列の店舗スライダー
    (() => {
      const locations = {
        krungsiam: 'data-krungSiamLocation',
        oldthailand: 'data-oldThailandLocation',
        thaifoodlabo: 'data-thaiFoodLaboLocation',
        thaistreetfood: 'data-thaiStreetFoodLocation',
      };

      // 現在地と比較して、listを返すためのdata-をリターン
      const getKey = () => {
        let locationName = '';
        const location = window.location.href;
        Object.entries(locations).forEach(([key, val]) => {
          if (location.includes(key)) {
            locationName = val;
          }
        });
        return locationName;
      };

      const shopSplideElement = document.querySelector('#shop-splide');
      const locationName = getKey();
      if (!shopSplideElement || locationName === '') return;
      const restaruntDetailSlider = new RestaurantDetailSlider({
        locationName: `[${locationName}]`,
      });
      restaruntDetailSlider.init();
    })();

    // ボタンをクリックした場合のアコーディオン
    (() => {
      const buttonText = (() => {
        // URLを判別し、テキストを返す
        function getTextByURL() {
          // URLを取得する
          const currentURL = window.location.href;
          // URLに'/th'もしくは'/en'で出力を変更する。
          if (currentURL.includes('/th/')) {
            return {
              openText: 'ดูอย่างละเอียด',
              closeText: 'ปิด',
            };
          } else if (currentURL.includes('/en/')) {
            return {
              openText: 'See More',
              closeText: 'close',
            };
          } else {
            return {
              openText: '詳しく見る',
              closeText: '閉じる',
            };
          }
        }
        return getTextByURL();
      })();

      const accordionButtons = document.querySelectorAll('[data="accordion-button"]');
      const openText = buttonText.openText;
      const closeText = buttonText.closeText;

      for (let i = 0; i < accordionButtons.length; i++) {
        let accordionButton = accordionButtons[i];
        // ボタンの親要素から見て次の要素を取得
        let accordionContent = accordionButton.parentElement.nextElementSibling;
        // snsアイコンの取得
        let snsIcon = accordionContent.querySelector('.c-shop-splide__card-sns');
        accordionButton.addEventListener('click', () => {
          accordionButton.classList.toggle('is-active');
          accordionContent.classList.toggle('is-open');
          // アコーディオンが開いているなら文言を変更し、SNSアイコンを表示
          if (accordionButton.classList.contains('is-active')) {
            accordionButton.firstElementChild.innerText = closeText;
            if (snsIcon) {
              snsIcon.style.display = 'block';
            }
          } else {
            accordionButton.firstElementChild.innerText = openText;
            if (snsIcon) {
              snsIcon.style.display = 'none';
            }
          }
        });
      }
    })();

    (() => {
      // モーダルとボタンを取得
      const modal = document.getElementById('banner-modal');
      const modalOverlay = document.getElementById('modal-overlay');
      const openButton = document.getElementById('banner-modal-open');
      const closeButton = document.getElementById('banner-modal-close');

      if (!modal) return;
      // モーダル背景クリックでモーダル非表示
      modalOverlay.addEventListener('click', function (e) {
        if (e.target === this) {
          modal.classList.remove('is-show');
          document.body.style.overflow = ''; // メインページのスクロールを元に戻す
        }
      });

      // ボタンクリックでモーダルを表示
      openButton.addEventListener('click', function () {
        modal.classList.add('is-show');
        document.body.style.overflow = 'hidden'; // メインページのスクロールを無効にする
      });

      // ボタンクリックでモーダルを非表示
      closeButton.addEventListener('click', function () {
        modal.classList.remove('is-show');
        document.body.style.overflow = ''; // メインページのスクロールを元に戻す
      });
    })();

    (() => {
      // モーダルとボタンを取得
      const modals = [...document.querySelectorAll('[data-modal]')];

      modals.forEach((modal) => {
        if (!modal) return;
        const key = modal.dataset.modal;
        const modalOverlay = modal.querySelector('.p-modal__overlay');
        const openButton = document.querySelector('[data-modal-open="' + key + '"]');
        if (openButton) {
          // 最後消す
          // ボタンクリックでモーダルを表示
          openButton.addEventListener('click', (_ev) => {
            modal.classList.add('is-show');
            document.body.style.overflow = 'hidden'; // メインページのスクロールを無効にする
          });
          // モーダル背景クリックでモーダル非表示
          modalOverlay.addEventListener('click', function (e) {
            if (e.target === this) {
              modal.classList.remove('is-show');
              document.body.style.overflow = ''; // メインページのスクロールを元に戻す
            }
          });
        } // 最後消す
      });
    })();

    // フローティングボタン
    (() => {
      let button = document.getElementById('floating-btn');
      if (!button) return;
      window.addEventListener('scroll', function () {
        if (window.scrollY > 1500) {
          button.style.display = 'block';
        } else {
          button.style.display = 'none';
        }
      });
    })();

    // お知らせボタン
    (() => {
      const button = document.getElementById('banner-modal-open');
      if (!button) return;

      const sectionTopBusiness = document.getElementById('top-business');
      const sectionTopBottomLink = document.getElementById('top-bottom-link');

      window.addEventListener('scroll', () => {
        const sectionTopBusinessTop = sectionTopBusiness.getBoundingClientRect().top;
        const sectionTopBottomLinkTop = sectionTopBottomLink.getBoundingClientRect().top;
        const bottomPosition = window.screen.height; // position bottom でお知らせボタンを固定したい位置

        // SP
        if (window.screen.width < 640) {
          if (sectionTopBottomLinkTop - 300 < bottomPosition) {
            button.classList.remove('fadeIn');
            return;
          } else {
            button.classList.add('fadeIn');
            return;
          }
        } else {
          // PC
          if (bottomPosition < sectionTopBottomLinkTop) {
            if (window.scrollY < 500) {
              button.classList.remove('fadeIn');
            } else {
              button.classList.add('fadeIn');
              button.style.bottom = '20px';
            }
          } else {
            const scrollHeight = `${bottomPosition - sectionTopBottomLinkTop}px`;
            button.style.position = 'fixed';
            button.style.bottom = scrollHeight;
          }
        }
      });
    })();
  })();
};

window.addEventListener('DOMContentLoaded', () => {
  adjustViewport();
  init();
});
